import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const BASE  = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const token = () => localStorage.getItem('kialuga_token');

function diasRestantes(prazo) {
  if (!prazo) return null;
  const diff = new Date(prazo).getTime() - Date.now();
  return Math.max(0, Math.ceil(diff / (1000 * 60 * 60 * 24)));
}

export default function AdicionarFotos() {
  const { id }    = useParams();
  const navigate  = useNavigate();

  const [produto,    setProduto]    = useState(null);
  const [ficheiros,  setFicheiros]  = useState([]);
  const [previews,   setPreviews]   = useState([]);
  const [uploading,  setUploading]  = useState(false);
  const [erro,       setErro]       = useState('');
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    fetch(`${BASE}/anuncios/${id}`, {
      headers: { Authorization: `Bearer ${token()}` },
    })
      .then(r => r.json())
      .then(d => { if (d.sucesso) setProduto(d.anuncio); })
      .catch(() => setErro('Produto não encontrado'))
      .finally(() => setCarregando(false));
  }, [id]);

  const adicionarFicheiros = e => {
    const novos = Array.from(e.target.files || []);
    const combined = [...ficheiros, ...novos].slice(0, 8);
    setFicheiros(combined);

    // Gerar previews para os novos ficheiros
    novos.forEach((f, i) => {
      const idx = ficheiros.length + i;
      if (idx >= 8) return;
      const reader = new FileReader();
      reader.onload = ev => {
        setPreviews(prev => {
          const next = [...prev];
          next[idx] = ev.target.result;
          return next;
        });
      };
      reader.readAsDataURL(f);
    });
  };

  const removerFoto = idx => {
    setFicheiros(prev => prev.filter((_, i) => i !== idx));
    setPreviews(prev => prev.filter((_, i) => i !== idx));
  };

  const submeter = async () => {
    if (ficheiros.length === 0) return;
    setUploading(true);
    setErro('');
    try {
      const form = new FormData();
      ficheiros.forEach(f => form.append('fotos', f));

      const res  = await fetch(`${BASE}/anuncios/${id}/fotos-produto`, {
        method:  'POST',
        headers: { Authorization: `Bearer ${token()}` },
        body:    form,
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.mensagem || 'Erro ao carregar fotos');

      navigate('/fornecedor/anuncios?activado=1');
    } catch (e) {
      setErro(e.message);
    }
    setUploading(false);
  };

  if (carregando) return (
    <div style={{ padding: '40px', textAlign: 'center', color: 'var(--text-secondary)' }}>
      A carregar...
    </div>
  );

  const dias = produto ? diasRestantes(produto.prazo_fotos) : null;

  return (
    <div style={{ maxWidth: '520px', margin: '0 auto', padding: '24px 16px' }}>
      <div style={{ marginBottom: '24px' }}>
        <button onClick={() => navigate(-1)}
          style={{ background: 'none', border: 'none', cursor: 'pointer',
            fontSize: '13px', color: 'var(--text-secondary)', marginBottom: '12px',
            padding: 0 }}>
          ← Voltar
        </button>
        <h1 style={{ fontSize: '20px', fontWeight: '700', color: 'var(--text-primary)', margin: 0 }}>
          Adicionar fotos
        </h1>
        {produto && (
          <p style={{ fontSize: '13px', color: 'var(--text-secondary)', marginTop: '4px' }}>
            {produto.titulo}
          </p>
        )}
      </div>

      {/* Aviso de prazo */}
      {dias !== null && dias <= 4 && (
        <div style={{ background: '#fef2f2', border: '1px solid #fecaca',
          borderRadius: '12px', padding: '12px 14px', marginBottom: '16px',
          fontSize: '13px', color: '#dc2626' }}>
          ⚠ Restam apenas <strong>{dias} dia(s)</strong> para adicionar fotos.
          Após o prazo, o produto será arquivado automaticamente.
        </div>
      )}

      {/* Grid de fotos */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '10px', marginBottom: '16px' }}>
        {previews.map((preview, i) => (
          <div key={i} style={{ position: 'relative', aspectRatio: '1', borderRadius: '12px', overflow: 'hidden' }}>
            <img src={preview} alt={`Foto ${i + 1}`}
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}/>
            <button onClick={() => removerFoto(i)}
              style={{ position: 'absolute', top: '6px', right: '6px',
                width: '22px', height: '22px', borderRadius: '50%', border: 'none',
                background: 'rgba(0,0,0,0.6)', color: '#fff', cursor: 'pointer',
                fontSize: '11px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              ✕
            </button>
            {i === 0 && (
              <span style={{ position: 'absolute', bottom: '6px', left: '6px',
                fontSize: '10px', background: 'rgba(0,0,0,0.6)', color: '#fff',
                padding: '2px 6px', borderRadius: '9999px' }}>
                Principal
              </span>
            )}
          </div>
        ))}

        {/* Botão adicionar */}
        {ficheiros.length < 8 && (
          <label style={{ aspectRatio: '1', cursor: 'pointer', display: 'block' }}>
            <div style={{ width: '100%', height: '100%', border: '2px dashed var(--border)',
              borderRadius: '12px', display: 'flex', flexDirection: 'column',
              alignItems: 'center', justifyContent: 'center',
              transition: 'border-color .15s, background .15s' }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--success)'; e.currentTarget.style.background = 'var(--success-bg)'; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.background = 'transparent'; }}>
              <span style={{ fontSize: '24px', marginBottom: '4px' }}>+</span>
              <span style={{ fontSize: '11px', color: 'var(--text-secondary)' }}>Adicionar</span>
            </div>
            <input type="file" accept="image/*" multiple style={{ display: 'none' }}
              onChange={adicionarFicheiros}/>
          </label>
        )}
      </div>

      <p style={{ fontSize: '12px', color: 'var(--text-secondary)', marginBottom: '20px' }}>
        Mínimo 1 foto · Máximo 8 fotos · A primeira foto é a foto principal
      </p>

      {erro && (
        <div style={{ background: 'var(--danger-bg)', border: '1px solid var(--danger-border)',
          borderRadius: '12px', padding: '12px 14px', marginBottom: '16px',
          fontSize: '13px', color: 'var(--danger)' }}>
          {erro}
        </div>
      )}

      <button onClick={submeter} disabled={ficheiros.length === 0 || uploading}
        style={{ width: '100%', padding: '14px', borderRadius: '14px', border: 'none',
          cursor: ficheiros.length === 0 || uploading ? 'not-allowed' : 'pointer',
          background: ficheiros.length === 0 || uploading ? 'var(--border)' : 'var(--success)',
          color: ficheiros.length === 0 || uploading ? 'var(--text-secondary)' : '#fff',
          fontSize: '15px', fontWeight: '700' }}>
        {uploading
          ? 'A carregar fotos...'
          : `Publicar produto com ${ficheiros.length} foto(s)`
        }
      </button>
    </div>
  );
}
